import { insertTrackEvent, requestInitialMetaFromStore, insertDataLayer } from './common.js';
import { getLoginType } from './registration.js';

const loginSuccess = ({ method = '', oldEvent = false, newEvent = false, frame }, callbackFunction) => {
	const label = method || getLoginType();

	// skip firing the event if method is missing
	if (!label) {
		return;
	}
	// fire both by default
	if (newEvent) {
		insertTrackEvent({
			category: 'Login',
			action: 'Successful',
			label
		});
	} else if (oldEvent) {
		insertTrackEvent({
			category: 'login',
			action: 'Successful',
			label
		});
	} else {
		insertTrackEvent({
			category: 'login',
			action: 'Successful',
			label
		});
		insertTrackEvent({
			category: 'Login',
			action: 'Successful',
			label
		});
	}
	requestInitialMetaFromStore({
		frame,
		cb: callbackFunction,
		delay: true
	});
};

const loginFailure = ({ method = null, error = '', oldEvent = false, newEvent = false }) => {
	let methodAUX = method;
	const loginType = getLoginType();

	if (method === 'GOOGLE') {
		methodAUX = method?.toLowerCase();
	}
	const label = `${loginType} - ${methodAUX} - ${error}`;
	// fire both by default
	if (newEvent) {
		insertTrackEvent({
			category: 'Login',
			action: 'Failed',
			label
		});
	} else if (oldEvent) {
		insertTrackEvent({
			category: 'login',
			action: 'Failed',
			label
		});
	} else {
		insertTrackEvent({
			category: 'login',
			action: 'Failed',
			label
		});
		insertTrackEvent({
			category: 'Login',
			action: 'Failed',
			label
		});
	}
	if (methodAUX === 'google') {
		insertDataLayer('SocialFlow', {
			social_network: method,
			pixel_screen: 'login-unsuccessful',
			pixel_action: 'none'
		});
	}
};

const logoutSuccess = (frame, callbackFunction) => {
	insertTrackEvent({
		category: 'logout',
		action: 'Successful'
	});
	requestInitialMetaFromStore({
		frame,
		callbackFunction
	});
};

export { loginSuccess, loginFailure, logoutSuccess };
